import { render, staticRenderFns } from "./LateralMenu.vue?vue&type=template&id=660d1960&scoped=true&lang=pug&"
import script from "./LateralMenu.vue?vue&type=script&lang=ts&"
export * from "./LateralMenu.vue?vue&type=script&lang=ts&"
import style0 from "./LateralMenu.vue?vue&type=style&index=0&id=660d1960&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660d1960",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
